import React from "react";
import { useParams } from "react-router-dom";
import { SubCreditListViewV2, ItemSubCredit } from "./SubCreditListView";
import { dateConverter } from "../../../../utils/dateConverter";
import { useSpendingDemandSubCreditList } from "../../hooks";
import { SubCredit } from "../../../credit/types/credit.type";
import UserInfo from "../../../user/components/UserInfo";
import EmptyListIcon from "../../../../components/atoms/EmptyListIcon/EmptyListIcon";
import Loader from "../../../../components/atoms/Loader/Loader";
import PaginationV2 from "../../../../components/organismes/PaginationV2/PaginationV2";
import { IconType } from "../../../../assets/JWayIcons";
import useNavigationApp from "../../../../navigation/hook/useNavigationApp";

export interface SubCreditListPresenterProps {
  spendingDemandId?: string;
  withSelectMode?: boolean;
  forUser?: boolean;
  pageSize?: number;
}

export default function SpendingDemandSubCreditListPresenter({
  spendingDemandId: spendingDemandIdProp,
  withSelectMode,
  forUser,
  pageSize = 10
}: SubCreditListPresenterProps) {
  const { spendingDemandId: spendingDemandIdParam } = useParams();
  const spendingDemandId = spendingDemandIdProp || spendingDemandIdParam || "";
  
  const { getAllQuery } = useSpendingDemandSubCreditList(spendingDemandId, {
    pageSize,
    disableQuery: !spendingDemandId
  });

  const { goToCredit } = useNavigationApp();

  const { data: subCreditListData, isLoading } = getAllQuery;
  const pagination = subCreditListData?.pagination;

  const handleClick = (creditId: string) => {
    // Only allow clicks for admin users (when forUser is false or undefined)
    if (!forUser) {
      goToCredit(creditId);
    }
  };

  const formated: ItemSubCredit[] | undefined =
    subCreditListData?.data?.map((subCredit: SubCredit) => {
      return {
        id: subCredit.s_credit_id,
        createdDate: dateConverter(subCredit.s_credit_creation_date_new),
        title: subCredit.s_credit_desc || `Sous-crédit ${subCredit.s_credit_id}`,
        description: subCredit.s_credit_desc,
        userFullNameRenderer: () => (
          <>
            <UserInfo id={subCredit.s_credit_user_id as any as string} info="username" limitText={10} />{" "}
            <UserInfo id={subCredit.s_credit_user_id as any as string} info="lastname" limitText={10} />{" "}
          </>
        ),
        amount: subCredit.s_credit_amount,
        status: "Actif",
        colorStatus: {
          backgroundColor: "#E8F5E9",
          color: "#2E7D32",
          iconType: undefined as IconType | undefined,
        },
        withPin: false,
        onClick: !forUser ? () => handleClick(subCredit.s_credit_src) : undefined,
      };
    });

  if (isLoading) {
    return <Loader paddingTop="20%" centered />;
  }

  if (!formated) {
    return <EmptyListIcon message="Une erreur est survenue" />;
  }

  if (formated && formated.length === 0) {
    return null;
  }

  return (
    <>
      <SubCreditListViewV2
        subCreditList={formated || []}
        isCheckMode={withSelectMode}
        noUser={forUser}
      />
      {pagination && (
        <PaginationV2
          centered
          currentPage={pagination?.current_page}
          lastPage={pagination?.total_pages}
          setCurrentPage={getAllQuery.setPage}
        />
      )}
    </>
  );
}

